export const ThirdWidth = `
	width: 440px;
	flex-grow: 0;
	flex-shrink: 0;
	@media (max-width: 1600px) { width: 360px; }
	@media (max-width: 1280px) { width: 300px; }
`;